export enum InfScanTypeEnum {
  unknown = 'unknown',
  stock = 'stock',
  stack = 'stack',
  order = 'order',
}
